import API from '../../apiCreate'
import { getParams } from '../../getParams'
import type { AxiosRequestConfig } from 'axios'
import type { ResponseUpdateIntegrationConfig } from '../crm-integrations.types'
import {
  PODPISLON_INTEGRATION_NAME,
  type PodpislonIntegrationUpdateConfigBody,
  type ResponseIntegrationList,
  type ResponsePodpislonIntegrationConfig,
  type ResponsePodpislonTestConnection,
} from './podpislon.types'

type ApiRequestConfigWithGlobalAlertFlag = AxiosRequestConfig & {
  skipGlobalErrorAlert?: boolean
}

const podpislonParams = { name: PODPISLON_INTEGRATION_NAME }

export const podpislonIntegrationApi = {
  getList: () => API.get<ResponseIntegrationList>('integration/list'),

  getConfig: () =>
    API.get<ResponsePodpislonIntegrationConfig>(
      `integration/get-config${getParams(podpislonParams)}`,
    ),

  updateConfig: (data: PodpislonIntegrationUpdateConfigBody) =>
    API.put<ResponseUpdateIntegrationConfig>(
      `integration/update-config${getParams(podpislonParams)}`,
      data,
    ),

  testConnection: () =>
    API.post<ResponsePodpislonTestConnection>(
      `integration/test-connection${getParams(podpislonParams)}`,
      undefined,
      { skipGlobalErrorAlert: true } as ApiRequestConfigWithGlobalAlertFlag,
    ),
}
